import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useTenant } from '../contexts/TenantContext'

export const useTournaments = () => {
  const { activeTenant } = useTenant()
  const [tournaments, setTournaments] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (activeTenant) {
      fetchTournaments()
    }
  }, [activeTenant])

  const fetchTournaments = async () => {
    try {
      const { data, error } = await supabase
        .from('tournaments')
        .select('*')
        .eq('tenant_id', activeTenant.id)
        .order('created_at', { ascending: false })

      if (error) throw error
      setTournaments(data || [])
    } catch (err) {
      console.error('Error fetching tournaments:', err)
    } finally {
      setLoading(false)
    }
  }

  const createTournament = async (tournamentData) => {
    const { data, error } = await supabase
      .from('tournaments')
      .insert([{ ...tournamentData, tenant_id: activeTenant.id }])
      .select()
      .single()

    if (error) throw error
    setTournaments([data, ...tournaments])
    return data
  }

  const deleteTournament = async (tournamentId) => {
    const { error } = await supabase
      .from('tournaments')
      .delete()
      .eq('id', tournamentId)
      .eq('tenant_id', activeTenant.id)

    if (error) throw error
    setTournaments(tournaments.filter(t => t.id !== tournamentId))
  }

  return { tournaments, loading, createTournament, deleteTournament, refetch: fetchTournaments }
}
